// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoDataValueModel {
    static getAttributeTypeMap() {
        return PorticoDataValueModel.attributeTypeMap;
    }
}
PorticoDataValueModel.discriminator = undefined;
PorticoDataValueModel.additionalProperties = false;
PorticoDataValueModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "dataRowId",
        "baseName": "dataRowId",
        "type": "string"
    },
    {
        "name": "dataColumnId",
        "baseName": "dataColumnId",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
];
//# sourceMappingURL=porticoDataValueModel.js.map